import { createGetAPI, createGetAllAPI, createPostAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

const CHATBOT_URL = `${BASE_URL}/chatbot`;

// --- Access Check ---

const { useGet: useCheckInternalTicketAccess } = createGetAPI({
  getURL: () => `${CHATBOT_URL}/internal-tickets/access/`,
});

// --- Internal Tickets ---

const { useGetAll: useGetInternalTickets } = createGetAllAPI({
  getURL: query => `${CHATBOT_URL}/internal-tickets/?${stringify(query || {})}`,
});

const { usePost: useCreateInternalTicket } = createPostAPI({
  getURL: () => `${CHATBOT_URL}/internal-tickets/`,
});

// --- Ticket Detail ---

const { useGet: useGetInternalTicketDetail } = createGetAPI({
  getURL: ticketId => `${CHATBOT_URL}/internal-tickets/${ticketId}/`,
});

// --- Messages ---

const { useGetAll: useGetInternalMessages } = createGetAllAPI({
  getURL: (ticketId, query) =>
    `${CHATBOT_URL}/internal-tickets/${ticketId}/messages/?${stringify(query || {})}`,
});

const { usePost: usePostInternalMessage } = createPostAPI({
  getURL: (_, ticketId) => `${CHATBOT_URL}/internal-tickets/${ticketId}/messages/`,
});

export {
  // Access
  useCheckInternalTicketAccess,
  // Tickets
  useGetInternalTickets,
  useCreateInternalTicket,
  useGetInternalTicketDetail,
  // Messages
  useGetInternalMessages,
  usePostInternalMessage,
};
